<template>
  <div>
    <label v-if="label" class="form-label" :for="id">{{ label }}</label>
    <small v-if="helper" class="form-text form-helper">{{ helper }}</small>
    <input
      :id="id"
      ref="input"
      v-bind="$attrs"
      :class="{
        success: !errors.length && value && valid,
        error: errors.length && validateError,
      }"
      type="file"
      :value="value"
      @input="$emit('input', $event.target.files[0])"
    />
    <Error v-if="errors.length" :errors="errors" />
  </div>
</template>

<script>
import Error from '@/Shared/Inputs/Error';
import helpers from '@/Mixins/helpers';

export default {
  mixins: [helpers],

  inheritAttrs: false,

  components: {
    Error,
  },

  props: {
    id: {
      default() {
        // eslint-disable-next-line no-underscore-dangle
        return `text-input-${this._uid}`;
      },
    },
    type: {
      type: String,
      default: 'text',
    },
    value: String,
    label: String,
    helper: String,
    errors: {
      type: Array,
      default: () => [],
    },
    validateSuccess: {
      type: Boolean,
      default: false,
    },
    validateError: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    valid() {
      if (!this.validateSuccess) return false;

      switch (this.type) {
        case 'email':
          return this.validateEmail(this.value);

        default:
          return this.value !== '';
      }
    },
  },

  methods: {
    focus() {
      this.$refs.input.focus();
    },
    select() {
      this.$refs.input.select();
    },
    setSelectionRange(start, end) {
      this.$refs.input.setSelectionRange(start, end);
    },
  },
};
</script>
